import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import EnvironmentService from 'cio/services/environment';
import EnvironmentModel from 'cio/models/environment';
import IntegrationsSegmentInIndexController from 'cio/pods/integrations/segment_in/controller';
import SegmentAuthService from 'cio/services/segment-auth';
import ApiCredentialsService from 'cio/services/api-credentials';
import IntegrationsController from 'cio/pods/integrations/index/controller';
import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';

export default class SegmentInRoute extends Route {
  @service environment!: EnvironmentService;
  @service router!: RouterService;
  @service segmentAuth!: SegmentAuthService;
  @service apiCredentials!: ApiCredentialsService;
  @service store!: DS.Store;

  crumb() {
    return {
      name: 'Segment',
      path: 'integrations.segment_in',
    };
  }

  model() {
    if (!this.environment.current.id) {
      return;
    }

    return this.store.findRecord('environment', this.environment.current.id);
  }

  setupController(controller: IntegrationsSegmentInIndexController, model: EnvironmentModel, transition: Transition) {
    super.setupController(controller, model, transition);

    let integrationsController = this.controllerFor('integrations.index') as IntegrationsController;

    this.segmentAuth.segmentIn.perform();
    this.apiCredentials.loadCurrentEnvironmentCredentials.perform();
    controller.loadSetupGuide.perform();
    integrationsController.segmentOut.perform();
  }

  resetController(controller: IntegrationsSegmentInIndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    controller.setProperties({
      alert: null,
      latestAuthenticateResponse: null,
    });

    this.segmentAuth.authenticate.cancelAll({ resetState: true });
    this.segmentAuth.segmentIn.cancelAll({ resetState: true });
  }
}
